import { render, staticRenderFns } from "./ProductCollections.vue?vue&type=template&id=14d65818&scoped=true&"
import script from "./ProductCollections.vue?vue&type=script&lang=js&"
export * from "./ProductCollections.vue?vue&type=script&lang=js&"
import style0 from "./ProductCollections.vue?vue&type=style&index=0&id=14d65818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d65818",
  null
  
)

export default component.exports